import React, { useEffect } from 'react';

import type { OptionsFromRequest } from '../../../../core/system/rendering/types.js';
import type { ByfunnFrapiStoryPage } from '../../../types/frapi-types.js';

import Navigation from '../../components/commonComponents/Navigation/Navigation.js';
import Footer from '../../components/commonComponents/Footer.js';
import { trackStoryPageView, withByfunnPulse } from '../../../pulse/index.js';
import { usePulseContext } from '../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import TeaserSearchResult from '../../components/teasers/TeaserSearchResult.js';

export type StoryPageProps = {
  data: ByfunnFrapiStoryPage;
  options: OptionsFromRequest;
};

const StoryPage: React.FC<StoryPageProps> = ({ data, options }) => {
  const { siteVersion, currentUrl } = options;
  const { info, articles } = data;
  const isMobile = siteVersion === 'phone';

  const { trackViewListing, registerViewElementTracking } = usePulseContext();

  useEffect(() => {
    trackStoryPageView(trackViewListing, currentUrl, 'story page');

    registerViewElementTracking();
  }, [trackViewListing, currentUrl, data, registerViewElementTracking]);

  return (
    <div className={`${siteVersion}-front`}>
      <Navigation fullWidth={!isMobile} />
      <div className="tag-page-container">
        <h1 className="story-title">{info?.title}</h1>
        <div className="description">{info?.background?.[0].text.value}</div>
        <div className="story-controls">
          <div className="story-hits">{`${articles.items.length} saker`}</div>
          <div className="story-sorting">{'Sortert nyeste først'}</div>
        </div>
        <div className="tag-articles-all-wrapper">
          <div className="tag-articles-all">
            {articles.items.map((item) => (
              <TeaserSearchResult
                {...item}
                key={item.id}
                size="small"
                mobile={isMobile}
                fullWidthTeaser={false}
                lazyLoad={false}
                colorPalette={undefined}
              />
            ))}
          </div>
        </div>
      </div>
      <Footer isMobile={isMobile} />
    </div>
  );
};

const StoryPageWithPulse = withByfunnPulse(StoryPage);

export { StoryPageWithPulse as StoryPage };
